/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingRuleCreateLineItemBase extends models.BillingRule {
    constructor() {
        super();
        this.setDiscriminator("BillingRuleCreateLineItemBase");
    }

    getFixupPrototypeFunction() { return BillingRuleCreateLineItemBase.fixupPrototype; }

    static newInstance(model: Partial<BillingRuleCreateLineItemBase>): BillingRuleCreateLineItemBase {
        let obj = Object.assign(new BillingRuleCreateLineItemBase(), model);
        BillingRuleCreateLineItemBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingRuleCreateLineItemBase>): BillingRuleCreateLineItemBase {
        if (!model) return null;
        return BillingRuleCreateLineItemBase.newInstance(<BillingRuleCreateLineItemBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingRuleCreateLineItemBase) {
        if (!obj) return;

        models.BillingRuleCreateLineItemBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingRuleCreateLineItemBase): boolean {
        if (models.BillingRule.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BillingRuleCreateLineItemBase.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.line_item_identity) {
            models.BillingLineItemIdentity.fixupPrototype(this.line_item_identity);
        }
        if (this.schedule) {
            models.BillingRuleRepeatingSchedule.fixupPrototype(this.schedule);
        }
        if (this.allocation) {
            models.BillingRuleAllocation.fixupPrototype(this.allocation);
        }
    }

    /**
     * Line item to create
     */
    line_item_identity: models.BillingLineItemIdentity;

    /**
     * Repeating schedule for the line item
     */
    schedule: models.BillingRuleRepeatingSchedule;

    /**
     * Allocation for the line item
     */
    allocation: models.BillingRuleAllocation;

}
